export const providerPaymentOption = {
  PATIENTFI: 'PATIENTFI',
  ALLEGRO: 'REGULAR',
};

export const providerSequence = {
  EXCELLENT: ['PATIENTFI', 'ALLEGRO', 'FORTIVA'],
  GOOD: ['ALLEGRO', 'PATIENTFI'],
  BAD: ['PATIENTFI'],
};
